import React, { useContext } from "react";
import { Grid, CircularProgress, Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import PropTypes from "prop-types";
import CurrentEvent from "./../../components/CurrentEvent/CurrentEvent";
import CurrentEvents from "../../components/CurrentEventsReview/CurrentEvents";
import { useHttp } from "../../hooks/http";
import { UserContext } from "../../UserContext";
import CommentsContainer from "./CommentsContainer";
const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  align: {
    textAlign: "center",
  },
  break: {
    [theme.breakpoints.down("md")]: {
      order: 2,
    },
  },
});

const Container = (props) => {
  const { event, access_token, contact, canViewComments } =
    useContext(UserContext);
  const { classes } = props;

  let hasId = sessionStorage.getItem("showOne") === "true";

  const [loaded, fetchedData] = useHttp(
    `clientPortal/clients/${contact.id}/currentEvents`,
    access_token,
    []
  );

  const events = fetchedData
    ? fetchedData.events.sort((a, b) => {
        return new Date(a.date) - new Date(b.date);
      })
    : [];

  if (canViewComments && event?.id) {
    return <CommentsContainer event={event}></CommentsContainer>;
  }
  if (!loaded) {
    return <CircularProgress />;
  }

  if (hasId && event) {
    return (
      <Grid container justifyContent="center">
        <CurrentEvent
          event={[event]}
          eventId={event.id}
          detectComment={props.detectComment}
        />
      </Grid>
    );
  }
  if (events.length === 0) {
    return (
      <Grid container justifyContent="center">
        <Grid item xs={12} className={classes.align}>
          <Typography variant="h5">You have no Current Events.</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent="center">
      <CurrentEvents events={events} />
    </Grid>
  );
};

Container.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Container);
